<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div>
	<k-menu bottom left accessible-popover accessible-label="User menu" content-id="cureum-user-menu-panel"><template v-slot:activator="{on, attrs}">
		<k-btn class="k-user-menu-show-large k-nocaps-btnx k-tight-btnx" v-on="on" v-bind="attrs" color="#666" dark accessible-label="Open user menu"><k-icon small class="mr-2">fas fa-user</k-icon><span class="k-user-menu-role-display">{{role_display}}</span></k-btn>
		<k-btn class="k-user-menu-show-small" v-on="on" v-bind="attrs" color="#666" icon dark accessible-label="Open user menu"><k-icon small>fas fa-user</k-icon></k-btn>
	</template>
		<k-list dense min-width="180">
			<k-list-item class="k-user-menu-show-small text-center"><k-list-item-title><b>{{user_info.first_name}} {{user_info.last_name}}</b></k-list-item-title></k-list-item>
			<k-divider class="k-user-menu-show-small"/>
			<!-- <k-list-item @click="change_role('admin')" v-if="show_role('admin')"><k-list-item-icon><k-icon small v-show="role=='admin'">fas fa-check</k-icon><k-icon small v-show="role!='admin'">fas fa-user</k-icon></k-list-item-icon><k-list-item-title>Site Admin</k-list-item-title></k-list-item>
			<k-list-item @click="change_role('staff')" v-if="show_role('staff')"><k-list-item-icon><k-icon small v-show="role=='staff'">fas fa-check</k-icon><k-icon small v-show="role!='staff'">fas fa-user</k-icon></k-list-item-icon><k-list-item-title>Staff</k-list-item-title></k-list-item>
			<k-list-item @click="change_role('student')" v-if="show_role('student')"><k-list-item-icon><k-icon small v-show="role=='student'">fas fa-check</k-icon><k-icon small v-show="role!='student'">fas fa-user</k-icon></k-list-item-icon><k-list-item-title>Student</k-list-item-title></k-list-item>
			<k-list-item @click="change_role('parent')" v-if="show_role('parent')"><k-list-item-icon><k-icon small v-show="role=='parent'">fas fa-check</k-icon><k-icon small v-show="role!='parent'">fas fa-user</k-icon></k-list-item-icon><k-list-item-title>Parent</k-list-item-title></k-list-item> -->
			<!-- note that the 'Simulate another user role' menu is for "sandbox" instances; it's not the same as mimicking another user -->
			<k-list-item @click="show_sandbox_simulate_role_menu" v-if="site_config.enable_sandbox_simulate_role_menu=='yes'"><k-list-item-icon><k-icon small>fas fa-user-secret</k-icon></k-list-item-icon><k-list-item-title>Simulate another user role...</k-list-item-title></k-list-item>
			<!-- ... nor is it the same as the "normal" simulate modce -->
			<k-list-item @click="show_simulate_role_menu" v-if="site_config.enable_simulate_role_menu=='yes'&&['staff','admin'].includes(role)"><k-list-item-icon><k-icon small>fas fa-user-secret</k-icon></k-list-item-icon><k-list-item-title>Simulate another user role...</k-list-item-title></k-list-item>
			<k-list-item @click="mimic_another_user" v-if="enable_mimic_another_user"><k-list-item-icon><k-icon small>fas fa-user-secret</k-icon></k-list-item-icon><k-list-item-title>{{mimic_user_noun}}</k-list-item-title></k-list-item>
			<k-divider/>
			<k-list-item v-if="show_weekly_lesson_plans" @click="lesson_reports_for_user_showing=true"><k-list-item-icon><k-icon small>fas fa-flag-checkered</k-icon></k-list-item-icon><k-list-item-title>Weekly Lesson Plans</k-list-item-title></k-list-item>
			<k-list-item v-if="show_school_admin_btn" @click="school_admin_interface_showing=true"><k-list-item-icon><k-icon small>fas fa-screwdriver-wrench</k-icon></k-list-item-icon><k-list-item-title>School Teacher Roll</k-list-item-title></k-list-item>
			<k-list-item v-if="show_update_sis_data_btn" @click="update_sis_data"><k-list-item-icon><k-icon small>fas fa-rotate</k-icon></k-list-item-icon><k-list-item-title>Update your class enrollments from Infinite Campus</k-list-item-title></k-list-item>
			<k-list-item v-if="show_resource_report_button" @click="show_resource_report"><k-list-item-icon><k-icon small>fas fa-table</k-icon></k-list-item-icon><k-list-item-title>View Resource Usage Report</k-list-item-title></k-list-item>
			<k-list-item v-if="asset_manager_enabled" @click="show_asset_manager"><k-list-item-icon><k-icon small>fas fa-file-certificate</k-icon></k-list-item-icon><k-list-item-title>{{site_config.asset_manager.text.name}}</k-list-item-title></k-list-item>
			<k-list-item v-if="false" @click="choose_beta_modes=true"><k-list-item-icon><k-icon small>fas fa-toggle-on</k-icon></k-list-item-icon><k-list-item-title>Choose <b style="font-weight:900"><span class="red--text text--darken-2">BETA FUNCTIONALITY</span></b></k-list-item-title></k-list-item>
			<k-list-item v-if="site_config.limit_courses_to_academic_year=='yes'"><k-list-item-icon><k-icon small>fas fa-calendar-alt</k-icon></k-list-item-icon><k-list-item-title>Academic Year {{academic_year_display}} <k-btn v-if="allow_academic_year_change" x-small color="secondary" style="margin-bottom:3px; margin-left:4px" @click="change_academic_year">Change</k-btn></k-list-item-title></k-list-item>
			
			<k-divider/>
			<!-- if we show the forgot password btn on the sign in screen, show the change password menu item here -->
			<k-list-item v-if="signed_in&&site_config.allow_new_users_to_self_identify_as_teacher=='yes'" @click="show_user_role_selection_interface"><k-list-item-icon><k-icon small>fas fa-user-gear</k-icon></k-list-item-icon><k-list-item-title>Manage User Role</k-list-item-title></k-list-item>
			<k-list-item v-if="site_config.show_forgot_password_btn=='yes'" @click="change_password"><k-list-item-icon><k-icon small>fas fa-key</k-icon></k-list-item-icon><k-list-item-title>Change Password</k-list-item-title></k-list-item>
			<k-list-item @click="sign_out"><k-list-item-icon><k-icon small>fas fa-sign-out-alt</k-icon></k-list-item-icon><k-list-item-title>Sign Out</k-list-item-title></k-list-item>
		</k-list>
	</k-menu>

	<k-dialog v-model="choose_beta_modes" max-width="800" persistent scrollable>
		<k-card>
			<k-card-title style="border-bottom:1px solid #999"><b>Beta Functionality</b></k-card-title>
			<k-card-text class="mt-3" style="font-size:16px">
				<div class="mb-2">Enable or disable the following {{ site_config.app_name }} <b style="font-weight:900"><span class="red--text text--darken-2">BETA FUNCTIONALITY</span></b>:</div>
			</k-card-text>

			<k-card-actions class="pa-3" style="border-top:1px solid #999">
				<k-spacer></k-spacer>
				<k-btn color="primary" @click="choose_beta_modes=false">Done</k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>

	<LessonReportsForUser v-if="lesson_reports_for_user_showing" :user_id_for_reports="user_info.user_id" @dialog_cancel="lesson_reports_for_user_showing=false" />
	<SchoolAdminInterface v-if="school_admin_interface_showing" @dialog_cancel="school_admin_interface_showing=false" />
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import SchoolAdminInterface from '../reports/SchoolAdminInterface.vue'
import LessonReportsForUser from '../lessons/LessonReportsForUser.vue'

export default {
	components: { SchoolAdminInterface, LessonReportsForUser },

	data() { return {
		choose_beta_modes: false,
		choose_beta_modes_more_info: false,
		beta_options: Object.assign({}, this.$store.state.lst.beta_options),
		lesson_reports_for_user_showing: false,
		school_admin_interface_showing: false,
	}},

	computed: {
		...mapState(['user_info', 'site_config']),
		...mapGetters(['academic_year_display', 'user_is_principal_or_ap','studentish_role', 'signed_in']),
		show_weekly_lesson_plans() {
			// config option determines if this is ever available
			if (this.site_config.show_weekly_lesson_plans == 'no') return false

			// *don't* show this to principals or aps?
			if (this.user_is_principal_or_ap) return false

			if (this.role == 'staff' || this.role == 'admin') return true
			// if (this.role == 'staff') return true	// note that we're showing this to staff, but not admins
		},
		show_school_admin_btn() {
			// config option determines if this is ever available
			if (this.site_config.show_school_leader_tools == 'no') return false
			if (this.user_is_principal_or_ap) return true
			if (this.role == 'admin') return true
		},
		show_update_sis_data_btn() {
			// used for districts; config option determines if available
			return (this.site_config.show_update_sis_data_btn == 'yes')
		},
		simulated_role: {
			get() { return this.$store.state.lst.simulated_role },
			set(val) { this.$store.commit('lst_set', ['simulated_role', val]) }
		},
		simulated_user: {
			get() { return this.$store.state.lst.simulated_user },
			set(val) { this.$store.commit('lst_set', ['simulated_user', val]) }
		},
		role() { return this.user_info.role },
		system_role() { return this.user_info.system_role },
		role_display() {
			if (this.role == 'parent') return 'Parent / Guardian'
			if (this.role == 'admin') return 'Site Admin'
			if (this.user_is_principal_or_ap) return 'School Leader'
			return U.capitalize_word(this.role)	// 'Staff' or 'Student'
		},
		allow_academic_year_change() {
			// show button to change AY if the user has rights to edit all LPs
			if (this.initialized < 0) return
			if (vapp.has_admin_right('lp.course.all')) return true
			return false
		},
		can_mimic_all_users() {
			if (vapp.has_admin_right('su')) return true
			if (vapp.has_admin_right('mimic_all')) return true
			return false
		},
		enable_mimic_another_user() {
			if (this.can_mimic_all_users) return true
			if (this.system_role == 'staff' && this.site_config.staff_can_mimic_users == 'yes') return true
			return false
		},
		show_resource_report_button() {
			// This button is enabled for staff users who have been granted Resource Report ('res_rep') admin rights, but are not superusers
			if (this.studentish_role) return false
			if (vapp.has_admin_right('su')) return false // 'su' level users access the resource report from Admin Tools
			if (vapp.has_admin_right('res_rep')) return true
			return false
		},
		mimic_user_noun() {
			if (this.can_mimic_all_users || this.user_is_principal_or_ap) return 'Mimic another user'
			else return 'Mimic one of your students'
		},
		asset_manager_enabled() {
			return this.site_config.asset_manager.enabled
		}
	},
	
	methods: {
		update_beta_options() {
			this.$store.commit('lst_set', ['beta_options', this.beta_options])
		},

		show_role(to_show) {
			// you can only adopt the admin role if your system_role is admin
			if (to_show == 'admin') {
				return this.system_role == 'admin'
			}

			if (to_show == 'staff') {
				return this.user_info.sis_identities.find(o=>{ return o.role == 'administrator' || o.role == 'teacher' }) || this.user_info.system_role == 'staff'
			}

			if (to_show == 'parent') {
				if (this.system_role == 'parent') return true
				if (this.site_config.show_parent_role_to_all_staff == 'yes') {
					if (this.system_role == 'staff' || this.system_role == 'admin') return true
				}
				return false
			}

			if (to_show == 'student') {
				return this.user_info.sis_identities.find(o=>{ return o.role == 'student' }) || this.user_info.system_role == 'student'
			}

			return false
		},

		show_user_role_selection_interface() {
			vapp.user_role_selection_interface_showing = true
		},

		// change_role(new_role) {
		// 	// for now we just set new role in local_storage and reload
		// 	U.local_storage_set('district_portal_chosen_role_' + this.user_info.user_id, new_role)
		// 	window.location.reload()
		// },

		change_role(new_role) {
			// if we're changing back to the user's system_role, cancel simulation
			if (new_role == this.system_role) {
				this.simulated_role = ''
				this.simulated_user = ''
			} else {
				// else set the new role in local_storage
				this.simulated_role = new_role
			}
			// then reload
			this.reload()
		},

		change_academic_year() {
			vapp.change_academic_year()
		},

		// TODO: fully implement this (from HenryConnects)
		mimic_another_user() {
			// superusers and users with mimic_all rights can mimic anyone
			if (this.can_mimic_all_users) {
				this.$prompt({
					text: 'Find the email address of the user you wish to mimic:',
					promptType: 'autocomplete',
					serviceName: 'email_search',
					initialValue: '',
					acceptText: 'Mimic User',
				}).then(email => {
					// return value should be e.g. 'pepper@gmail.com (Pepper Williams)'; extract the email
					email = $.trim(email).toLowerCase().replace(/^(\S+).*/, '$1')

					if (empty(email) || email.indexOf('@') == -1) {
						this.$alert('Please enter a valid user email.').then(x=>{this.mimic_another_user()})
						return
					}
					
					this.simulated_user = email
					this.reload()
					
				}).catch(n => {console.error(n)})

			} else if (this.user_is_principal_or_ap) {
				// principals/aps can mimic others from their schools; first get a list of them
				U.loading_start()
				// U.ajax('get_all_users_for_department', {user_id:this.user_info.user_id, department:['Impact Academy']}, result=>{
				U.ajax('get_all_users_for_department', {user_id:this.user_info.user_id, department:this.user_info.district_department}, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						this.$alert('Error loading search results.')
						return
					}
					let arr = []
					for (let row of result.users) arr.push({value: row.email, text: `${row.first_name} ${row.last_name} (${row.email})`})
					this.$prompt({
						text: 'Choose a user from your school or department that you wish to mimic:',
						promptType: 'autocomplete',
						autocompleteItems: arr,
						initialValue: '',
						acceptText: 'Mimic User',
					}).then(email => {
						// return value should be e.g. 'pepper@gmail.com (Pepper Williams)'; extract the email
						email = $.trim(email).toLowerCase().replace(/^(\S+).*/, '$1')

						if (empty(email) || email.indexOf('@') == -1) {
							this.$alert('Please choose a user.').then(x=>{this.mimic_another_user()})
							return
						}
						
						this.simulated_user = email
						this.reload()
						
					}).catch(n => {console.error(n)})
				});

			} else if (this.system_role == 'staff') {
				// teachers can mimic their students; get a list of them
				let arr = []
				for (let cl of this.$store.state.sis_classes) {
					if (!empty(cl.students)) for (let sarr of cl.students) {
						if (!empty(sarr)) for (let s of sarr) {
							if (!empty(s) && !arr.find(x=>x.value == s.email)) {
								arr.push({value: s.email, text: `${s.givenName} ${s.familyName} (${s.email})`})
							}
						}
					}
				}
				
				arr.sort((a,b) => U.natural_sort(a.text, b.text))
				this.$prompt({
					text: 'Choose a student that you wish to mimic:',
					promptType: 'autocomplete',
					autocompleteItems: arr,
					initialValue: '',
					acceptText: 'Mimic Student',
				}).then(email => {
					// return value should be e.g. 'pepper@gmail.com (Pepper Williams)'; extract the email
					email = $.trim(email).toLowerCase().replace(/^(\S+).*/, '$1')

					if (empty(email) || email.indexOf('@') == -1) {
						this.$alert('Please choose a student.').then(x=>{this.mimic_another_user()})
						return
					}
					
					this.simulated_user = email
					this.reload()
					
				}).catch(n => {console.error(n)})
			}
		},

		// TODO: fully implement this (from HenryConnects)
		update_sis_data() {
			this.$confirm({
				title: 'Update Class Enrollments',
				text: `To update your class enrollments from Infinite Campus, click PROCEED below, then sign back in to ${this.site_config.app_name}.<div class="mt-2"><b>Note:</b> your class enrollments are automatically checked, and updated if necessary, the first time you sign in to HenryConnects each day, so the only reason you should need to run this “manual” update process is if you think your enrollments may have changed in the last 24 hours.</div>`,
				acceptText: 'Proceed',
				dialogMaxWidth: 540,
				focusBtn: true,		// focus on the accept btn when dialog is rendered
			}).then(y => {
				this.$store.dispatch('update_sis_data')
			}).catch(n => {console.error(n)})
		},

		show_sandbox_simulate_role_menu() {
			this.$prompt({
				title: 'Simulate Another User Role',
				text: `By default, user accounts in this “sandbox” version of ${this.site_config.app_name} simulate an agency staff member with no courses specified in their SIS.<ul class="my-2"><li>Choose from the menu below, then click “SIMULATE ROLE” to simulate a different role.</li><li>Click “RETURN TO DEFAULT ROLE” to return to your default role.</li></ul>`,
				promptType: 'select',
				selectOptions: [{value:'', text: 'Choose a role…'}, 
					{value:'default', text:'My Demo Staff Account'},
					// {value:'elena.espinoza@agency.edu', text:'Elena Espinoza (5th-grade teacher)'},
					// {value:'mark.mcghee@agency.edu', text:'Mark Mcghee (8th-grade ELA teacher)'},
					// {value:'hillary.hutchinson@agency.edu', text:'Hillary Hutchinson (HS social studies teacher)'},
					{value:'m.jones@cglt.school.edu', text:'Martha Jones (principal)'},
					// {value:'patpalmer@gmail.com', text:'Pat Palmer (parent)'},
				],
				dialogMaxWidth: 540,
				initialValue: '',
				acceptText: 'Choose Selected Role',
				acceptIcon: 'fas fa-user-secret',
				cancelText: 'Stay in Current Role',
				cancelIcon: 'fas fa-xmark',
			}).then(email => {
				if (email == 'default') email = ''
				vapp.simulate_sandbox_role(email)
				
			}).catch(n=>{
				
			})
		},

		show_simulate_role_menu() {
			let options = [{value:'', text: 'Choose a role…'}]
			if (['admin'].includes(this.role)) options.push({value: 'staff', text: 'Teacher'})
			options.push({value: 'parent', text: 'Parent/Guardian'})
			options.push({value: 'student', text: 'Student'})
			this.$prompt({
				title: 'Simulate Another User Role',
				text: `Choose from the menu below, then click “SIMULATE ROLE” to simulate a different role.`,	// <div class="mt-2">Click “RETURN TO DEFAULT ROLE” to return to your default role.</div>`,
				promptType: 'select',
				selectOptions: options,
				dialogMaxWidth: 540,
				initialValue: '',
				acceptText: 'Choose Selected Role',
				acceptIcon: 'fas fa-user-secret',
				cancelText: 'Stay in Current Role',
				cancelIcon: 'fas fa-xmark',
			}).then(role => {
				this.change_role(role)
				
			}).catch(n=>{
				
			})
		},

		reload() {
			// TODO: be a little more careful about what page we're sending the person to depending on the role?
			// for now, just reload if we're viewing a collection (since you may be viewing what the page looks like in the other role); otherwise send to /welcome
			if (window.location.toString().indexOf('/collection/') > -1) {
				window.location.reload()
			} else {
				window.location = '/home'
			}
		},

		sign_out() {
			this.$store.dispatch('sign_out')
		},

		change_password() {
			vapp.change_password()
		},

		show_resource_report() {
			this.$router.push({path: '/resource_usage'})
		},

		show_asset_manager() {
			this.$router.push({path: '/asset_manager'})
		},
	}
}
</script>

<style lang="scss">
.k-user-menu-show-large { display:flex; }
.k-user-menu-show-small { display:none; }
</style>
